/**
 * 工作区元素拖入页面时的页板高亮（仅选框，无手柄）。
 */
import { SelectionChromeFrame } from '@/components/canvas/selection/SelectionChromeFrame';
import { selectionChromeWorldMetrics } from '@/components/canvas/selection/selectionChrome';

export interface PageDropTargetOverlayProps {
  pageWidth: number;
  pageHeight: number;
  zoom: number;
}

export function PageDropTargetOverlay({ pageWidth, pageHeight, zoom }: PageDropTargetOverlayProps) {
  const { inset, pad } = selectionChromeWorldMetrics(zoom);
  return (
    <SelectionChromeFrame
      left={-inset}
      top={-inset}
      width={pageWidth + pad}
      height={pageHeight + pad}
      zoom={zoom}
    />
  );
}
